export default "__VITE_ASSET__COE554cY__"